import { Component } from 'react';
import { default as ReactPhoneInput } from 'react-phone-number-input';

import 'react-phone-number-input/style.css';

/**
 * Phone input component
 * @deprecated Use the Trellis Input.Phone component instead: https://main--6710219e5989b079dbcc9421.chromatic.com/?path=/docs/components-input-phone--docs
 */
class PhoneInput extends Component {
	state = {
		region: this.props.region || 'US',
		selectedCountry: null,
		inputValue: '',
		value: this.props.value
	};

	componentDidUpdate(prevProps, prevState) {
		if (prevState.value != this.state.value) {
			if (this.props.onChange) {
				this.props.onChange(this.state.value);
			}
		} else if (prevProps.value != this.props.value) {
			this.setState({
				value: this.props.value
			});
		}
	}

	handleChange = value => {
		this.setState({ value });
	};

	render() {
		const { value } = this.state;
		const { disabled, placeholder = 'Type a phone number' } = this.props;

		return <ReactPhoneInput disabled={disabled} defaultCountry="US" onChange={this.handleChange} value={value} placeholder={placeholder} />;
	}
}

PhoneInput.propTypes = {};

export default PhoneInput;
